import { ButtonBase, Stack, Typography } from "@mui/material";

interface GraphBarChartLegendProps {
	title?: string;
	primaryLable: string;
	secondaryLable: string;
	primaryColor?: string;
	secondaryColor?: string;
	primaryActive?: boolean;
	secondaryActive?: boolean;
	onPrimaryClick?: VoidFunction;
	onSecondaryClick?: VoidFunction;
}

type LegendItemProps = {
	label: string;
	color: string;
	active: boolean;
	onClick?: VoidFunction;
};

const LegendItem = ({ label, color, active, onClick }: LegendItemProps) => {
	const content = (
		<Stack
			direction="row"
			spacing={1}
			alignItems="center"
			sx={{
				opacity: active ? 1 : 0.4,
				transition: "opacity 150ms ease-in-out",
			}}
		>
			<Stack width={12} height={12} borderRadius={1} bgcolor={color} />

			<Typography variant="caption" fontWeight={500}>
				{label}
			</Typography>
		</Stack>
	);

	if (!onClick) {
		return content;
	}

	return (
		<ButtonBase onClick={onClick} aria-pressed={active} sx={{ borderRadius: 1, p: 0.5 }}>
			{content}
		</ButtonBase>
	);
};

export const GraphBarChartLegend = ({
	title,
	primaryLable,
	secondaryLable,
	primaryColor = "error.main",
	secondaryColor = "success.main",
	primaryActive = true,
	secondaryActive = true,
	onPrimaryClick,
	onSecondaryClick,
}: GraphBarChartLegendProps) => {
	return (
		<Stack gap={0.5} alignItems="center">
			<Typography variant="body2" fontWeight={500}>
				{title}
			</Typography>
			<Stack direction="row" spacing={2} justifyContent="center">
				<LegendItem
					label={primaryLable}
					color={primaryColor}
					active={primaryActive}
					onClick={onPrimaryClick}
				/>

				<LegendItem
					label={secondaryLable}
					color={secondaryColor}
					active={secondaryActive}
					onClick={onSecondaryClick}
				/>
			</Stack>
		</Stack>
	);
};
